/**
 * Copyright ToolBelt Data Inc., 2021 All Rights Reserved
 */

import React from "react";
import FormTextInput from "../../../../../common/components/FormTextInput";
import InsightBox from "../InsightBox";

const FilterTextInput = (props) => {
    const {
        ftOption,
        stateObj,
        handleKeyValueChange,
        handleSubmitFilter
    } = props;

    if (!ftOption) return null;

    const { id, label, placeholder, insight, isLocked, preview, infoText } = ftOption;

    const rawValue = stateObj?.[id];

    const textValue = (typeof rawValue === 'object' && rawValue !== null)
        ? rawValue.value
        : (rawValue ?? '');

    const handleSubmit = () => {
        if (textValue) {
            console.log('Submitting Value:', textValue);
            handleSubmitFilter({
                ...ftOption,
                value: textValue
            });
        }
    };

    const handleClear = () => {
        handleKeyValueChange(id, '');
        handleSubmitFilter({
            id: id,
            value: ''
        });
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleSubmit();
        }
    };

    return (
        <div>
            <FormTextInput
                id={`${id}-text-input`}
                label={label}
                placeholder={placeholder}
                value={textValue}
                onChange={(value) => handleKeyValueChange(id, value)}
                onBlur={handleSubmit}
                onKeyDown={handleKeyDown}
                clearable={!!textValue}
                clearableHandle={handleClear}
                disabled={isLocked}
                lockIcon={isLocked}
                isPreview={preview}
                infoText={infoText}
            />
            {insight && (
                <div style={{ marginTop: '8px' }}>
                    <InsightBox
                        text={insight.text}
                        title={insight.title}
                    />
                </div>
            )}
        </div>
    );
}

export default FilterTextInput;